export const rights = [1, 2, 3, 4, 5];

export const devlopment_mode = true;
